import { https, httpsFile } from "./http";

export function update(id,data){
    return https().post(`/discounts/${id}`,data);
}

export function show(id){
    return https().get(`/discounts/${id}`);
}